import React from 'react';
import Icon from '../../../components/AppIcon';

const TimelineSlider = ({ currentAge, retirementAge, onRetirementAgeChange }) => {
  const minAge = currentAge + 5;
  const maxAge = 75;
  const yearsToRetirement = retirementAge - currentAge;

  const handleSliderChange = (e) => {
    onRetirementAgeChange(parseInt(e?.target?.value));
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="flex items-center justify-center w-10 h-10 rounded-lg bg-primary/10">
          <Icon name="Calendar" size={20} className="text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Retirement Timeline</h3>
          <p className="text-sm text-muted-foreground">Adjust your target retirement age</p>
        </div>
      </div>

      <div className="space-y-6">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm font-medium text-muted-foreground">Current Age</p>
            <p className="text-2xl font-bold text-foreground">{currentAge} years</p>
          </div>
          <div className="text-right">
            <p className="text-sm font-medium text-muted-foreground">Retirement Age</p>
            <p className="text-2xl font-bold text-primary">{retirementAge} years</p>
          </div>
        </div>

        <div className="relative">
          <input
            type="range"
            min={minAge}
            max={maxAge}
            value={retirementAge}
            onChange={handleSliderChange}
            className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer accent-primary"
            style={{
              background: `linear-gradient(to right, var(--color-primary) 0%, var(--color-primary) ${((retirementAge - minAge) / (maxAge - minAge)) * 100}%, var(--color-muted) ${((retirementAge - minAge) / (maxAge - minAge)) * 100}%, var(--color-muted) 100%)`
            }}
          />
          <div className="flex justify-between mt-2">
            <span className="text-xs text-muted-foreground">{minAge}</span>
            <span className="text-xs text-muted-foreground">{maxAge}</span>
          </div>
        </div>

        <div className="grid grid-cols-2 gap-4">
          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Clock" size={16} className="text-primary" />
              <p className="text-xs font-medium text-muted-foreground">Years to Retirement</p>
            </div>
            <p className="text-xl font-bold text-foreground">{yearsToRetirement}</p>
          </div>

          <div className="bg-muted/50 rounded-lg p-4">
            <div className="flex items-center gap-2 mb-2">
              <Icon name="Target" size={16} className="text-accent" />
              <p className="text-xs font-medium text-muted-foreground">Planning Horizon</p>
            </div>
            <p className="text-xl font-bold text-foreground">{yearsToRetirement} years</p>
          </div>
        </div>

        <div className="p-4 bg-primary/5 border border-primary/20 rounded-lg">
          <div className="flex items-start gap-2">
            <Icon name="Info" size={16} className="text-primary mt-0.5 flex-shrink-0" />
            <p className="text-xs text-muted-foreground">
              Retiring later gives you more time to save and reduces the corpus needed. However, consider your health, career prospects, and personal goals when setting your retirement age.
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TimelineSlider;